module.exports = __webpack_public_path__ + "media/unipod/eight_step4-50ceb4b7.jpg";